import { ImageInterface } from 'common/types/entities/ImageInterface'

interface ImageSourceEntity
  extends Pick<
    ImageInterface,
    'fileId' | 'mobileFileId' | 'externalUrl' | 'mobileExternalUrl'
  > {}

export interface ImageSourceInput {
  entity: ImageSourceEntity
  desktopFilePath?: string
  mobileFilePath?: string
  fallbackDesktopSrc?: string
}

export interface ImageSourceResult {
  imageSrc: string
  mobileImageSrc?: string
}

export const getImageSourceResult = ({
  entity,
  desktopFilePath,
  mobileFilePath,
  fallbackDesktopSrc = '',
}: ImageSourceInput): ImageSourceResult => {
  const imageSrc = desktopFilePath || entity.externalUrl || fallbackDesktopSrc

  const hasMobileImageSource =
    entity.mobileFileId !== undefined || entity.mobileExternalUrl !== undefined

  const mobileImageSrc = hasMobileImageSource
    ? mobileFilePath || entity.mobileExternalUrl || undefined
    : undefined

  return {
    imageSrc,
    mobileImageSrc,
  }
}
